import React, {FC, ReactNode} from 'react';

import {ContactSourcesEnum} from '../../../../../libs/shared/core/src/models/api/contactModel';
import {ContactCardPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {InlineLinkButton} from '../../../../../libs/shared/ui/src/components/buttons/inlineLinkButton';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {ContactCardLocationsEnum} from '../../../../store/panels/contacts/contactCard/contactCardPanelState';
import {ContactCardSectionItem} from './contactCardSectionItem';

/*
 * Props.
 */

interface ContactCardHandleItemProps {
  handle: string;
  title: ReactNode;
  hasChannel: boolean;
  isUserVisitor: boolean;
  source: ContactSourcesEnum;
  onComposeMessage: () => void;
  location?: ContactCardLocationsEnum;
  panelId?: ContactCardPanelId;
}

/*
 * Component.
 */

export const ContactCardHandleItem: FC<ContactCardHandleItemProps> = (props) => {
  const {handle, title, hasChannel, isUserVisitor, source, onComposeMessage, location, panelId} = props;
  return (
    <ContactCardSectionItem
      title={title}
      copyInfo={handle}
      handle={handle}
      source={source}
      location={location}
      panelId={panelId}
    >
      <TooltipCoordinator placement="top" render={() => handle}>
        {renderHandleOrComposeLink(hasChannel, handle, isUserVisitor, onComposeMessage)}
      </TooltipCoordinator>
    </ContactCardSectionItem>
  );
};

/*
 * Helpers.
 */

function renderHandleOrComposeLink(
  hasChannel: boolean,
  handle: string,
  isUserVisitor: boolean,
  onComposeMessage: () => void,
) {
  // If the user is a visitor, we should treat the email links as mailto links.
  if (isUserVisitor) {
    return (
      <InlineLinkButton onClick={() => openInBrowser(`mailto:${handle}`)}>
        <TooltipOverflowCondition>{handle}</TooltipOverflowCondition>
      </InlineLinkButton>
    );
  }
  if (!hasChannel) {
    return <TooltipOverflowCondition>{handle}</TooltipOverflowCondition>;
  }
  return (
    <InlineLinkButton onClick={onComposeMessage}>
      <TooltipOverflowCondition>{handle}</TooltipOverflowCondition>
    </InlineLinkButton>
  );
}
